import {
  effectiveSubscriptionTierForPlanUi,
  isEnterpriseSubscriptionTier,
  subscriptionTierToPlan,
} from "@neuraville/react-core-pro/subscription";

/**
 * Resolves the raw subscription tier string from the portal auth user object.
 * Prefers explicit profile field, then Firebase JWT custom claim `tier`.
 */
export function resolveAuthUserSubscriptionTier(user) {
  if (!user || typeof user !== "object") {
    return "";
  }
  if (typeof user.subscription_tier === "string" && user.subscription_tier.trim()) {
    return user.subscription_tier.trim();
  }
  const claims = user.customClaims;
  if (claims && typeof claims.tier === "string" && claims.tier.trim()) {
    return claims.tier.trim();
  }
  return "";
}

/**
 * Effective tier for navbar badge (matches feagi-desktop Launcher / account plan UI).
 */
export function subscriptionTierForNavUi(user) {
  return effectiveSubscriptionTierForPlanUi(
    resolveAuthUserSubscriptionTier(user),
    user?.roles
  );
}

/** Lowercase slug shown in the navbar badge (community, pro, team, enterprise). */
export function subscriptionTierBadgeLabelForNav(user) {
  const plan = subscriptionTierToPlan(subscriptionTierForNavUi(user));
  return plan === "unknown" ? "community" : plan;
}

/** Whether the navbar badge should use Enterprise (gold) styling. */
export function isEnterpriseTierForNav(user) {
  return isEnterpriseSubscriptionTier(subscriptionTierForNavUi(user));
}
